import React from "react";

export function useResubmitPrompt({ open, onResubmit, onDismiss }) {
  const [reason, setReason] = React.useState("");
  const [resubmitting, setResubmitting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    if (open) {
      setReason("");
      setErrorMessage("");
      setResubmitting(false);
    }
  }, [open]);

  const dismiss = React.useCallback(() => {
    if (!resubmitting) {
      onDismiss();
    }
  }, [onDismiss, resubmitting]);

  const confirmResubmission = React.useCallback(async () => {
    const trimmedReason = reason.trim();
    if (!trimmedReason || resubmitting) {
      return;
    }

    setResubmitting(true);
    setErrorMessage("");
    try {
      await onResubmit(trimmedReason);
      onDismiss();
    } catch (error) {
      setErrorMessage(error?.message ?? "Unable to resubmit the timecard.");
    } finally {
      setResubmitting(false);
    }
  }, [onDismiss, onResubmit, reason, resubmitting]);

  return {
    reason,
    setReason,
    resubmitting,
    errorMessage,
    canResubmit: Boolean(reason.trim()) && !resubmitting,
    confirmResubmission,
    dismiss
  };
}
